/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

import Image from '../../../../../../components/ZUILib/Image';
// import Link from '../../../../../../components/ZUILib/Link';

import * as giftListActions from '../../actions';
import commonUtil from '../../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../../utils/clientConstant';
import GiftListConfigureWap from '../GiftListConfigureWap';
import EventCardProfile from '../../../../../../components/EventTemplate/EventCardProfile';

const applicationRoutes = commonUtil.getApplicationRoutes();

const { getEventSummaryInfo } = giftListActions;
class GiftListHeaderWap extends Component {
  eventStatusInfo = '';
  redirectToEventManagement = () => {
    browserHistory.push(
      commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: 'EventManagementIndex',
        eventID: this.props.eventId,
      }),
    );
  };

  render() {
    const eventSummaryResponse = this.props.eventSummaryInfoHeader;
    const eventStatus = this.props.summaryInfoResponse && this.props.summaryInfoResponse.eventInfo
      && this.props.summaryInfoResponse.eventInfo.eventStatus ? this.props.summaryInfoResponse.eventInfo.eventStatus : null;
    const eventType = eventSummaryResponse && eventSummaryResponse.eventInfo ? eventSummaryResponse.eventInfo.eventType : undefined;
    let eventIconImageURL = commonUtil.getAssetURL() + '/images/gifts/gift_bodas.svg';
    switch (eventType) {
      case defaultConst.eventType.Boda:
      case defaultConst.eventType.Aniversario:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_bodas.svg';
        break;
      case defaultConst.eventType.Baptism:
      case defaultConst.eventType.Bebe:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_bebes.svg';
        break;
      case defaultConst.eventType.XV_Anos:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_quince.svg';
        break;
      case defaultConst.eventType.Bar_Mitzvah:
      case defaultConst.eventType.Bat_Mitzvah:
      case defaultConst.eventType.First_Communion:
      case defaultConst.eventType.Confirmacion:
      case defaultConst.eventType.Despedida:
      case defaultConst.eventType.Open_House:
      case defaultConst.eventType.Other_Religious_Ceremonies:
      case defaultConst.eventType.Others:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_ceremonias.svg';
        break;
      case defaultConst.eventType.Mascotas:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_ceremonias.svg';
        break;
      case defaultConst.eventType.Fiesta_Infantil:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_cumple.svg';
        break;
      case defaultConst.eventType.Cumpleanos:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_cumpleanos.svg';
        break;
      case defaultConst.eventType.Fiesta_Reunion:
        eventIconImageURL =
          commonUtil.getAssetURL() + '/images/gifts/gift_todotipo.svg';
        break;
      default:
        break;
    }
    const eventIconImageAttr = {
      id: 'img1',
      alt: 'Liverpool',
      src: eventIconImageURL,
      altImg: commonUtil.getAssetURL() + '/images/gifts/gift_bebes.svg',
      className: 'eventMessageImage',
    };

    if (eventSummaryResponse && eventSummaryResponse.status === 'success') {
      if (
        this.props.compareEventStatus(
          eventStatus,
          defaultConst.eventStatus.SUSPENDED_FOR_TIME,
        ) ||
        this.props.compareEventStatus(
          eventStatus,
          defaultConst.eventStatus.DELETED,
        )
      ) {
        browserHistory.push(
          commonUtil.getRouteByParameter('/eventoEstadoSuspendidoPorTiempo'),
        );
      }
      eventSummaryResponse.eventInfo.isSuspended = true;
      if (this.props.handleSuspendedEventUpdate) {
        // && response.eventInfo.isSuspended
        this.props.handleSuspendedEventUpdate(eventSummaryResponse);
      }
      this.eventStatusInfo = eventSummaryResponse.eventInfo.eventStatus;
    }
    const lables = this.props.lables;
    // const _imgsrc = [
    //   {
    //     srcSet: eventSummaryResponse && eventSummaryResponse.eventInfo && eventSummaryResponse.eventInfo.eventProfileImage
      // && eventSummaryResponse.eventInfo.eventProfileImage, // TODO: Need to upload all images in static asset
    //   },
    // ];
    const imageAttr = {
      id: 'img1',
      alt: 'Liverpool',
      src:
        eventSummaryResponse &&
        eventSummaryResponse.eventInfo &&
        eventSummaryResponse.eventInfo.eventProfileImage,
      // altImg: commonUtil.getAssetURL() + '/images/addImageIcon.svg', // TODO: Need to upload all images in static asset
      altImg: commonUtil.getAssetURL() + '/images/avatar.svg',
    };
    // const linkDatosDeEvento = {
    //   route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'DatosDeMiEvento', eventID: this.props.eventId }),
    // };
    if (!eventSummaryResponse) {
      return null;
    }
    if (eventSummaryResponse.eventInfo) {
      // let newMessage = '';
      // let messageFlag = false;
      if (eventSummaryResponse.eventInfo.eventCountdownMsg) {
        const fullMsg = eventSummaryResponse.eventInfo.eventCountdownMsg;
        if (fullMsg.includes(':')) {
          // newMessage = fullMsg.split(':');
          // messageFlag = true;
        }
      }
      return (
        <React.Fragment>
          {eventSummaryResponse.targeterContents ? (
            <div className="row">
              <div className="col-xs-12">
                {eventSummaryResponse.eventInfo.eventStatus ===
                defaultConst.eventStatus.ACTIVE ? (
                  <React.Fragment>
                    {this.props.showBanner === true ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: eventSummaryResponse.targeterContents[0].data,
                        }}
                      />
                    ) : (
                      ''
                    )}
                  </React.Fragment>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: eventSummaryResponse.targeterContents[0].data,
                    }}
                  />
                )}
              </div>
            </div>
          ) : (
            ''
          )}
          <div className="row">
          <div className="event-customization">
              <EventCardProfile
                selectedTheme={this.props.selectedTheme || {}}
                handleSuspendedEventUpdate={this.props.handleSuspendedEventUpdate}
                eventId={this.props.eventId}
                lables={this.props.lables}
                compareEventStatus={this.props.compareEventStatus}
                summaryInfoResponse={this.props.summaryInfoResponse}
                icon={this.props.eventIcon}
                eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                ownerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user1firstName || ""} coOwnerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user2firstName || ""} CelebrityName={""} message={this.props?.giftList?.eventSummaryInfo?.eventInfo?.comment} eventDateValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventDate || ""} eventTxtValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventName || ""}
              />
            </div>
        </div>
       

          {/* <div
            className="row adminInfo"
            onClick={this.redirectToEventManagement}
          >
           
            <div className="col-xs-3 p-l-0">
              <Image imageAttr={imageAttr} />
            </div>
            {this.eventStatusInfo !== defaultConst.eventStatus.SUSPENDED ? (
              <div className="col-xs-7 p-l-0">
                <h2>{eventSummaryResponse.eventInfo.eventName}</h2>
                <span className="eventDate">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    'adminpage.summary.date.of.event.label',
                  )}
                  : {eventSummaryResponse.eventInfo.eventDate}
                </span>
                <span className="eventDate">
                  Número del evento: {eventSummaryResponse.eventInfo.eventId}
                </span>
                {eventSummaryResponse.eventInfo.eventCountdown ? (
                  <span className="eventDate">
                    <h5>
                      {' '}
                      {eventSummaryResponse.eventInfo.eventCountdown} &nbsp;
                      {lables ? (
                        commonUtil.getLabel(
                          lables.EventAdminPage,
                          'adminpage.summary.daysleft.message',
                        )
                      ) : (
                        <div className="daysLeft congratulations">
                          <div>
                            <Image imageAttr={eventIconImageAttr} />
                          </div>
                          <p>
                            {' '}
                            {eventSummaryResponse.eventInfo.eventCountdownMsg}
                          </p>
                        </div>
                      )}
                    </h5>
                  </span>
                ) : (
                  ''
                )}
              </div>
            ) : (
              <div className="col-xs-7">
                <h2>{eventSummaryResponse.eventInfo.eventName}</h2>
                <span className="eventDate">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    'adminpage.summary.date.of.event.label',
                  )}
                  : {eventSummaryResponse.eventInfo.eventDate}
                </span>{' '}
              </div>
            )}
            <div className="col-xs-2">
              {/* <Link rrLink={linkDatosDeEvento}> 
              <i className="icon-flecha_gruesa_derecha" />
              {/* </Link> 
            </div>
          </div> */}
          {/* {!eventSummaryResponse.eventInfo.eventCountdown && this.eventStatusInfo !== defaultConst.eventStatus.SUSPENDED ?
            <div className='row adminInfo pt10 pb10'>
              <React.Fragment>
                <div className='col-xs-3'>
                  <span className='eventDate text-center'>
                    <Image imageAttr={eventIconImageAttr} />
                  </span>
                </div>
                <div className='col-xs-9 p-l-0 p-b-0'>
                  {eventSummaryResponse.eventInfo.eventCountdownMsg && messageFlag ? <React.Fragment>
                    <h4 className='newMessageIcon'>
                      {newMessage[0]}</h4>
                    <h3 className='eventCongratulationsMessage'> {newMessage[1]}</h3>
                  </React.Fragment> :
                  <React.Fragment>
                    <h4>&nbsp;</h4>
                    <h3 className='eventCongratulationsMessage'> {eventSummaryResponse.eventInfo.eventCountdownMsg}</h3>
                  </React.Fragment>}
                </div></React.Fragment>
            </div> : ''} */}
        </React.Fragment>
      );
    }
    return null;
  }
}

const matchDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getEventSummaryInfo,
    },
    dispatch,
  );
const mapStateToProps = state => ({
  eventInfo: state.giftList.data,
  eventSummaryInfoHeader:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo, //  && state.giftList.data.eventSummaryInfo,
  user: state.user.data,
});

export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(GiftListHeaderWap);
